import {Injectable} from '@angular/core';
import {ApiConfig} from '../core/config/api.config';
import {BASE_SERVICE} from '../core/config/api.constants';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ApiResponse} from './api-response.model';
import {endpoint} from './path.constants';

@Injectable({providedIn: 'root'})
export class OtpService {

  private readonly baseUrl = ApiConfig.getBaseUrl(BASE_SERVICE);

  constructor(private http: HttpClient) {
  }

  sendOtp(payload: {
    otp_type: 'sign_up_otp' | 'verify_institute_otp';
    email?: string;
    mobile?: number;
  }) {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.post<ApiResponse<any>>(
      this.baseUrl + endpoint.base.send_otp, payload, {headers}
    );
  }

  verifyOtp(payload: {
    otp_type: 'sign_up_otp' | 'verify_institute_otp';
    email?: string;
    mobile?: number;
    received_otp: number;
  }) {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.post<ApiResponse<any>>(
      this.baseUrl + endpoint.base.verify_otp, payload, {headers}
    );
  }
}
